import React from 'react';
import { useHistory } from 'react-router-dom';
import { getCallableFunction } from '../../../firebase/firebase';
import { ChoiceButtonsComponent } from '../../base/button/ChoiceButtons';
import { MainBodyTextComponent } from '../../base/mainBodyText/MainBodyText';
import { PageContainerComponent } from '../../base/pageContainer/PageContainer';
export const ResetWorldTour = (props: any) => {
  const history = useHistory();
  const resetWorldTour = getCallableFunction('resetWorldTourProgress');
  return (
    <PageContainerComponent>
      <MainBodyTextComponent>Reset World Tour Progress?</MainBodyTextComponent>
      <ChoiceButtonsComponent
        primaryButtonText="reset"
        primaryButtonAction={() => {
          resetWorldTour({}).then(() => history.push('/'));
        }}
        secondaryButtonText="cancel"
        secondaryButtonAction={() => history.goBack()}
      />
    </PageContainerComponent>
  );
};
